import React from "react";

const HomePage = () => {
    return (
        <div className="container py-5 px-3 text-center">
            <h1 className="mb-4 text-break">Ласкаво просимо до Lava Studio</h1>
            <p className="text-muted text-break">Оберіть потрібний розділ у меню вище.</p>
        </div>
    );
};

export default HomePage;
